import firebase from 'firebase';
import 'firebase/firestore';

import config from './config';

firebase.initializeApp(config);



// WEBPACK FOOTER //
// ./src/firebase/initialization.js